module.exports = __webpack_public_path__ + "img/belgium-cardiovascular-diseases-female.3122cb3a.png";